// @ts-check

/**
 * CUSTOM: Slider til Trustpilot-anmeldelser. Markup: sections/custom-trustpilot-reviews.liquid
 * Bygget på CSS scroll-snap (giver naturlig swipe på mobil); JS styrer kun pile + tastatur.
 * - ←/→ på pilene eller piletasterne, når slideren har fokus.
 * - Pilene deaktiveres i start/slut og skjules, hvis alle anmeldelser er synlige.
 * Ren logik i CustomTrustpilotReviews.arrowState() – kan testes isoleret.
 */
(function () {
  if (customElements.get('custom-trustpilot-reviews')) return;

  /**
   * Ren logik: hvilke pile skal være aktive?
   * @param {number} scrollLeft
   * @param {number} scrollWidth
   * @param {number} clientWidth
   * @returns {{ prev: boolean, next: boolean, scrollable: boolean }}
   */
  function arrowState(scrollLeft, scrollWidth, clientWidth) {
    const max = scrollWidth - clientWidth;
    const tolerance = 2;
    return {
      prev: scrollLeft > tolerance,
      next: scrollLeft < max - tolerance,
      scrollable: max > tolerance,
    };
  }

  class CustomTrustpilotReviews extends HTMLElement {
    connectedCallback() {
      /** @type {HTMLElement | null} */
      this.track = this.querySelector('[data-tp-track]');
      /** @type {HTMLButtonElement | null} */
      this.prev = this.querySelector('[data-tp-prev]');
      /** @type {HTMLButtonElement | null} */
      this.next = this.querySelector('[data-tp-next]');
      if (!this.track || !this.prev || !this.next) return;

      this.prev.addEventListener('click', () => this.go(-1));
      this.next.addEventListener('click', () => this.go(1));
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.go(-1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.go(1);
        }
      });

      /** @type {number | undefined} */
      let frame;
      this.track.addEventListener(
        'scroll',
        () => {
          if (frame) cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => this.update());
        },
        { passive: true }
      );
      if ('ResizeObserver' in window) {
        new ResizeObserver(() => this.update()).observe(this.track);
      }

      // Theme editor: vis den valgte anmeldelse.
      document.addEventListener('shopify:block:select', (e) => {
        const target = /** @type {HTMLElement} */ (e.target);
        if (this.track && this.track.contains(target)) {
          this.track.scrollTo({ left: target.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        }
      });

      this.update();
    }

    /** @param {number} direction -1 = tilbage, 1 = frem (én anmeldelse ad gangen) */
    go(direction) {
      if (!this.track) return;
      const card = /** @type {HTMLElement | null} */ (this.track.querySelector('[data-tp-card]'));
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: reduced ? 'auto' : 'smooth' });
    }

    update() {
      if (!this.track || !this.prev || !this.next) return;
      const state = arrowState(this.track.scrollLeft, this.track.scrollWidth, this.track.clientWidth);
      this.prev.disabled = !state.prev;
      this.next.disabled = !state.next;
      this.toggleAttribute('data-scrollable', state.scrollable);
    }
  }

  /** @type {any} */ (CustomTrustpilotReviews).arrowState = arrowState;
  customElements.define('custom-trustpilot-reviews', CustomTrustpilotReviews);
})();
